import { Box, IconButton } from "@mui/material";
import { styled } from "styled-components";

export const ToolbarContainer = styled(Box)<{ $isTabPresent: boolean }>(({ $isTabPresent }) => ({
  alignItems: "center",
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  flex: "none",
  height: "56px",
  position: "relative",
  width: "100%",
  pointerEvents: "none",
  "& button": {
    pointerEvents: "auto",
    zIndex: 7001,
  },
  ...($isTabPresent && {
    marginTop: "40px",
  }),
}));

export const InnerMenuContainer = styled(Box)<{
  $isPublicSingleShare: boolean;
  $isMobile: boolean;
  $leftDrawer: boolean;
  $leftDrawerAutoHide: boolean;
}>(({ $isPublicSingleShare, $isMobile, $leftDrawer, $leftDrawerAutoHide }) => ({
  alignItems: "center",
  display: "flex",
  flex: 1,
  flexDirection: "row",
  gap: "16px",
  height: "100%",
  marginLeft: $isPublicSingleShare
    ? "0px"
    : $isMobile
      ? "40px"
      : $leftDrawer
        ? $leftDrawerAutoHide
          ? "0px"
          : "240px"
        : $leftDrawerAutoHide
          ? "0px"
          : "40px",
  padding: "0px 16px",
}));

export const BigIconButton = styled(IconButton)({
  position: "absolute",
  left: "16px",
});

export const SmallIconButton = styled(IconButton)({
  background: "black",
  width: "40px",
  height: "40px",
  color: "white",
  fontSize: "16px",
});

export const TitleContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
});

export const AllElementsContainer = styled(Box)({
  display: "flex",
  flexDirection: "row-reverse",
  height: "100%",
});
